import 'react-loading-skeleton/dist/skeleton.css';

import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import styles from '../styles/SpotEstimateFormLoader.module.scss';

function SpotEstimateFormLoaderCmp(): React.ReactElement {
  return (
    <SkeletonTheme baseColor="#e6e6e6" duration={2} highlightColor="#FEFEFE">
      <div className={styles['vehicle-results-wrapper']}>
        <div className={styles['vehicles-wrapper']}>
          <Skeleton
            height="4.4rem"
            borderRadius="0.4rem"
            containerClassName={styles['skeleton-2']}
          />
        </div>
        <div className={styles['vehicles-wrapper']}>
          <Skeleton
            height="4.4rem"
            borderRadius="0.4rem"
            containerClassName={styles['skeleton-2']}
          />
        </div>
        <div className={styles['vehicles-wrapper']}>
          <Skeleton
            height="4.4rem"
            borderRadius="0.4rem"
            containerClassName={styles['skeleton-2']}
          />
        </div>
      </div>
    </SkeletonTheme>
  );
}

export default SpotEstimateFormLoaderCmp;
